module.exports = __webpack_public_path__ + "assets/foxford.ru.63919d558950dead7a7205876b8cfabcd586843507591edb6451914552b148df.jpg";